import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Menu, Tabs } from 'antd';
import SellerActions from '@Actions/sellerActions';
import { H3_TITLE } from '@Apis/constants';
import VendorProducts from '@Components/Vendors/VendorProfile/VendorProducts';
import VendorOverview from '@Components/Vendors/VendorProfile/VendorOverview';
import VendorPurchaseOrders from '@Components/Vendors/VendorProfile/VendorPurchaseOrders';
import VendorPurchaseLedger from '@Components/Vendors/VendorProfile/VendorPurchaseLedger';
import VendorPayments from '@Components/Vendors/VendorProfile/VendorPayments';
import Helpers from '@Apis/helpers';
import AccountStatement from './AccountStatement';
import './style.scss';
import HideComponent from '../../Common/RestrictedAccess/HideComponent';

const { TabPane } = Tabs;
/**
 *
 */
class ViewSeller extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentTab: '/overview',
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      match, getSellerById, user,
    } = this.props;
    const { vendorId } = match.params;
    getSellerById(vendorId, user?.tenant_info?.tenant_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const key = new URLSearchParams(location.search).get('tab');
    return {
      ...state,
      currentTab: key || '/overview',
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getSellerByIdLoading, selectedSeller, user, history, priceMasking,
    } = this.props;
    const { currentTab } = this.state;

    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="view-vendor__wrapper">
          <div className="view-vendor__details">
            { !getSellerByIdLoading
              ? (
                <Fragment>
                  <div className="org-sellers__add-wrapper-header-left">
                    <div>
                      <div className="org-sellers__add-wrapper-header-right-text-title">
                        {`${selectedSeller?.seller_info?.internal_slr_code} - ${selectedSeller?.seller_info?.seller_name}`}
                      </div>
                    </div>
                  </div>
                </Fragment>
              )
              : (
                <div className="org-sellers__details-loader-wrapper">
                  <div className="loadingBlock org-sellers__details-loader-title" />
                </div>
              )}
          </div>
          <Tabs
            activeKey={currentTab.toString()}
            onChange={(key) => {
              this.setState({ currentTab: key });
              history.push(`?tab=${key}`);
            }}
            mode="horizontal"
          >
            <TabPane tab="Overview" key="/overview" />
            {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.READ, user) && <TabPane tab="Catalogue" key="/catalogue" />}
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) && <TabPane tab="Purchase Orders" key="/purchase-orders" />}
            {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user) && window.innerWidth > 425 && <TabPane tab="Payments" key="/payments" />}
            {Helpers.getPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.CREATE, user) && window.innerWidth > 425 && <TabPane tab="Purchase Ledger" key="/purchase-ledger" />}
            {window.innerWidth > 425 && <TabPane tab="Statement" key="/account-statement" />}
          </Tabs>
          {currentTab === '/overview' && <VendorOverview /> }
          {currentTab === '/catalogue' && ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideComponent /> : <VendorProducts />) }
          {currentTab === '/purchase-orders' && <VendorPurchaseOrders /> }
          {currentTab === '/payments' && window.innerWidth > 425 && ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideComponent /> : <VendorPayments />) }
          {currentTab === '/purchase-ledger' && window.innerWidth > 425 && ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideComponent /> : <VendorPurchaseLedger />) }
          {currentTab === '/account-statement' && window.innerWidth > 425 && ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideComponent /> : <AccountStatement />) }
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ SellerReducers, UserReducers }) => ({
  getSellerByIdLoading: SellerReducers.getSellerByIdLoading,
  selectedSeller: SellerReducers.selectedSeller,
  user: UserReducers.user,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getSellerById: (vendorId, tenantId) => dispatch(SellerActions.getSellerById(vendorId, tenantId)),
});

ViewSeller.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getSellerById: PropTypes.func,
  selectedSeller: PropTypes.any,
  getSellerByIdLoading: PropTypes.bool,
  history: PropTypes.func,
  location: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewSeller));
